<template>
  <div class="login_wraaper">
    <div class="user">
      <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">
      <img class="title-image" src="/image/login_header.png" alt="">
      <h4 class="title">中国辞书学会</h4>
      <el-form-item prop="username">
        <el-input v-model="loginForm.username" type="text" autocomplete="off" :maxlength="maxlength" placeholder="账号">
          <i class="el-icon-user" slot="prefix"></i>
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="loginForm.password"
          type="password"
          autocomplete="off"
          :maxlength="maxlength"
          placeholder="密码"
          @keyup.enter.native="handleLogin"
        >
        <i class="el-icon-lock" slot="prefix"></i>
        </el-input>
      </el-form-item>
      <el-form-item prop="code" >
        <el-input
          v-model="loginForm.code"
          autocomplete="off"
          placeholder="验证码"
          maxlength="4"
          style="float:left; width: 60%"
          @keyup.enter.native="handleLogin"
        >
          <i class="el-icon-lock" slot="prefix"></i>
        </el-input>
        <div class="login-code">
          <img :src="codeUrl" @click="getCode" class="login-code-img"/>
        </div>
      </el-form-item>
      <el-checkbox v-model="loginForm.rememberMe" style="float:left; margin:0px 0px 25px 0px;">记住密码</el-checkbox>
      <el-form-item style="width:100%;">
        <el-button
          :loading="loading"
          size="medium"
          type="primary"
          style="width:100%;"
          @click.native.prevent="handleLogin"
        >
          <span v-if="!loading">登 录</span>
          <span v-else>登 录 中...</span>
        </el-button>
        <!-- <div style="float: right;" v-if="register">
          <router-link class="link-type" :to="'/register'">立即注册</router-link>
        </div> -->
      </el-form-item>
      </el-form>
    </div>
    <div class="copyright">
      <a target="_blank" href="https://beian.miit.gov.cn/"> 京ICP备2020036770号-1 </a >
    </div>
  </div>
</template>

<script>
import LoginApi from '@/api/login'
import { mapRequestActions } from '@/utils'
import Cookies from 'js-cookie'
import { setToken, getToken, setLoginUserInfo, userPermission, setUserRoles } from '@/utils/auth.js'
export default {
  data: function () {
    return {
      loading: false,
      codeUrl: '',
      redirect: undefined,
      maxlength: 50,
      loginForm: {
        username: '',
        password: '',
        rememberMe: false,
        code: '',
        uuid: ''
      },
      loginRules: {
        username: [
          { required: true, trigger: 'blur', message: '请输入您的账号' }
        ],
        password: [
          { required: true, trigger: 'blur', message: '请输入您的密码' }
        ],
        code: [{ required: true, trigger: 'change', message: '请输入验证码' }]
      }
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  created () {
    // getToken() || this.getCode()
    if (Cookies.get('rememberMe')) {
      this.loginForm.username = Cookies.get('username')
      this.loginForm.password = Cookies.get('password')
      this.loginForm.rememberMe = true
    }
    if (getToken()) {
      this.$router.push({ path: this.redirect || '/home' }).catch(() => {})
    } else {
      this.getCode()
    }
  },
  methods: {
    ...mapRequestActions(LoginApi),
    handleLogin () {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          // 勾选记住密码
          if (this.loginForm.rememberMe) {
            Cookies.set('username', this.loginForm.username, { expires: 20 })
            // Cookies.set('password', encrypt(this.loginForm.password), { expires: 30 })
            Cookies.set('password', this.loginForm.password, { expires: 20 })
            Cookies.set('rememberMe', this.loginForm.rememberMe, { expires: 20 })
          } else {
            Cookies.remove('username')
            Cookies.remove('password')
            Cookies.remove('rememberMe')
          }
          setLoginUserInfo(this.loginForm)
          this.hanldeLoginAction(this.loginForm).then((res) => {
            if (res.status) {
              setToken(res.result.token || '')
              userPermission(res.result.permissions)
              setUserRoles(res.result.roles)
              this.$message({
                type: 'success',
                message: '登录成功'
              })
              this.$router.push({ path: this.redirect || '/home' }).catch(() => {})
            } else {
              this.loading = false
              this.$message.error(res.errorMsg)
              this.getCode()
              this.loginForm.code = ''
            }
          }).catch(() => {
            this.loading = false
            if (this.captchaOnOff) {
              this.getCode()
            }
          })
        }
      })
      // this.$router.push('/home')
    },
    getCode () {
      this.getVerCodeAction().then(res => {
        this.codeUrl = 'data:image/gif;base64,' + res.result.img
        this.loginForm.uuid = res.result.uuid || ''
      })
    }
  }
}
</script>

<style lang='less' scoped>
@import './login.less';
</style>
